import { costCenterListHref, projectCostCenterHref } from "./costCenterDisplay";

export type DetailLocationState = { from?: string } | null;

export type BackTarget = {
  to: string;
  label: string;
};

type BackTargetInput = {
  from?: string;
  fallback: BackTarget;
};

const ROUTE_BACK_TARGETS: Array<{
  match: (path: string) => boolean;
  label: string;
}> = [
  { match: (path) => path === "/", label: "← zurück zur Übersicht" },
  {
    match: (path) => routePath(path) === "/cost-centers",
    label: "← zurück zu den Kostenstellen",
  },
  {
    match: (path) => path.startsWith("/cost-centers/detail/"),
    label: "← zurück zur Kostenstelle",
  },
  {
    match: (path) => path === "/projects",
    label: "← zurück zu den Projekten",
  },
  {
    match: (path) => path === "/belege",
    label: "← zurück zu den Belegen",
  },
  { match: (path) => path === "/rechnungspruefung", label: "← zurück zur Rechnungsprüfung" },
  { match: (path) => path === "/bestellungen", label: "← zurück zu den Bestellungen" },
  { match: (path) => path === "/preisspiegel", label: "← zurück zum Preisspiegel" },
  {
    match: (path) => path === "/orders",
    label: "← zurück zu den Aufträgen",
  },
  {
    match: (path) => path.startsWith("/projects/"),
    label: "← zurück zum Projekt",
  },
  {
    match: (path) => path === "/articles",
    label: "← zurück zu den Artikeln",
  },
  {
    match: (path) => path.startsWith("/articles/"),
    label: "← zurück zum Artikel",
  },
  {
    match: (path) => path.startsWith("/reports/variance"),
    label: "← zurück zur Analyse",
  },
  { match: (path) => path.startsWith("/imports"), label: "← zurück zum Import" },
];

export function backTargetFromLocationState({
  from,
  fallback,
}: BackTargetInput): BackTarget {
  const normalized = normalizeFromPath(from);
  if (!normalized) return fallback;
  const normalizedPath = routePath(normalized);
  if (normalizedPath === "/reports/variance" && new URLSearchParams(normalized.split("?")[1]?.split("#")[0]).get("report") === "1") {
    return { to: normalized, label: "← Zurück zum Preisbericht" };
  }
  const target = ROUTE_BACK_TARGETS.find((candidate) =>
    candidate.match(normalizedPath),
  );
  return {
    to: normalized,
    label: target?.label ?? "← zurück",
  };
}

function normalizeFromPath(value: string | undefined): string | null {
  if (!value) return null;
  if (!value.startsWith("/")) return null;
  if (value.startsWith("//")) return null;
  if (value === "/projects") return costCenterListHref("project");
  if (value.startsWith("/projects/")) {
    const projectKey = value.split(/[?#]/, 1)[0]?.slice("/projects/".length);
    if (projectKey) {
      return projectCostCenterHref(safeDecodePathSegment(projectKey)) ?? costCenterListHref("project");
    }
  }
  return value;
}

function safeDecodePathSegment(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function routePath(value: string): string {
  return value.split(/[?#]/, 1)[0] ?? value;
}
